<!-- ===== HERO ===== -->
<section class="hero">
  <div class="container narrow">
    <h1 class="hero__title">
      <span class="hero__top">{{ t('hero.top') }}</span>
      <span class="hero__line">
        <span class="type t1" style="--nch:22;">{{ t('hero.typing1') }}</span>
        <span class="type t2" style="--nch:20;">{{ t('hero.typing2') }}</span>
      </span>
    </h1>
  </div>

  <div class="hero-video">
    <video
      #vid
      class="hero-video__media"
      src="assets/videos/alphatec-hero.mp4"
      poster="assets/videos/alphatec-hero.png"
      autoplay muted loop playsinline preload="metadata"
      controlslist="nodownload noplaybackrate nofullscreen"
      disablepictureinpicture>
      {{ t('hero.noSupport') }}
    </video>

    <div class="hero-video__overlay" aria-hidden="true"></div>

    <!-- Botón Play/Pause -->
    <button
      class="hero-video__ctrl"
      type="button"
      (click)="toggleVideo(vid)"
      [class.is-paused]="!playing"
      [attr.aria-pressed]="playing ? 'true' : 'false'"
      [attr.aria-label]="playing ? t('hero.aria.pause') : t('hero.aria.play')"
      [title]="playing ? t('hero.aria.pause') : t('hero.aria.play')">
      <span class="ring" aria-hidden="true"></span>
      <span class="ic ic-pause" aria-hidden="true"></span>
      <span class="ic ic-play" aria-hidden="true"></span>
    </button>

    <!-- Texto + CTAs -->
    <div class="hero-cta" role="group" [attr.aria-label]="t('hero.actionsLbl')">
      <p class="hero-cta__lead">{{ t('hero.lead') }}</p>
      <div class="cta-row">
        <a class="btn btn-xl btn-pro-glass" routerLink="/tienda">{{ t('hero.ctaExplore') }}</a>
        <a class="btn btn-xl btn-ghost-orange" routerLink="/contacto">{{ t('hero.ctaQuote') }}</a>
      </div>
    </div>
  </div>
</section>

<br>

<!-- ===== Nuestras categorías ===== -->
<section class="cats section-dark">
  <div class="container">
    <header class="cats__head">
      <h2 class="text-brand-orange">{{ t('cats.title') }}</h2>
      <p class="sub">{{ t('cats.subtitle') }}</p>
    </header>

    <div id="catCarousel"
         class="carousel slide cats__carousel"
         data-bs-ride="carousel"
         data-bs-interval="5200"
         data-bs-pause="hover">

      <div class="carousel-indicators">
        <button *ngFor="let _ of categorySlides; let i = index"
                type="button"
                data-bs-target="#catCarousel"
                [attr.data-bs-slide-to]="i"
                [class.active]="i===0"
                [attr.aria-current]="i===0 ? 'true' : null"
                [attr.aria-label]="t('common.slide') + ' ' + (i+1)"></button>
      </div>

      <div class="carousel-inner">
        <div class="carousel-item" *ngFor="let slide of categorySlides; let si = index" [class.active]="si===0">
          <div class="cats-grid">
            <a class="cat-item panel-card"
               *ngFor="let c of slide; trackBy: trackByCategory"
               [routerLink]="['/categoria', c.slug]"
               [attr.aria-label]="c.name">
              <figure class="cat-item__figure">
                <img [src]="'assets/categories/' + c.file" [alt]="c.name" loading="lazy">
              </figure>
              <span class="cat-item__name">{{ c.name }}</span>
            </a>
          </div>
        </div>
      </div>

      <button class="carousel-control-prev" type="button" data-bs-target="#catCarousel" data-bs-slide="prev" [attr.aria-label]="t('common.prev')">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#catCarousel" data-bs-slide="next" [attr.aria-label]="t('common.next')">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
      </button>
    </div>

    <div class="cta-row mt-cta">
      <a class="btn btn-pro" routerLink="/tienda">{{ t('cats.btnViewCats') }}</a>
      <a class="btn btn-glass-blue" routerLink="/contacto">{{ t('cats.btnQuote') }}</a>
    </div>
  </div>
</section>

<!-- ===== Sobre nosotros ===== -->
<section class="about">
  <div class="container">
    <div class="about_head">
      <h2>
        <img src="assets/logo/icon_alp.png" width="70" alt="">
        Alphatec Scientific®
      </h2>
      <p class="accent-2 mini-green">TECHNOLOGY CARE</p>
    </div>

    <div class="connect__grid">
      <figure class="media-card">
        <video
          class="media-card__media"
          src="assets/videos/vid_01.mp4"
          autoplay muted loop playsinline preload="metadata"
          controlslist="nodownload noplaybackrate nofullscreen"
          disablepictureinpicture>
        </video>
      </figure>

      <div class="connect__content">
        <div class="bullets">
          
          <p><img src="assets/logo/alphatec_name.png" width="85" alt="Alphatec"> {{ t('about.p1') }}</p>
          <p>
            {{ t('about.p2a') }}
            <img src="assets/logo/alphatec_name.png" width="85" alt="Alphatec">
            {{ t('about.p2b') }}
          </p>
        </div>

        <div class="cta-row">
          <a routerLink="/nosotros" class="btn btn-pro">{{ t('about.btnMore') }}</a>
          <a routerLink="/contacto" class="btn btn-pro-outline">{{ t('about.btnContact') }}</a>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ===== Serie M ===== -->
<section class="series">
  <div class="container">
    <h2 class="series__title">
      {{ t('series.titleA') }} <span class="accent-2">{{ t('series.series') }}</span><br>
      Alphatec Scientific®.<br>
      <small class="text-brand-orange-light">{{ t('series.subtitle') }}</small>
    </h2>

    <div id="seriesCarousel"
         class="carousel slide series__carousel"
         data-bs-ride="carousel"
         data-bs-touch="true"
         data-bs-interval="4500"
         data-bs-pause="false">

      <div class="carousel-indicators">
        <button *ngFor="let _ of serieMSlides; let i = index"
                type="button"
                data-bs-target="#seriesCarousel"
                [attr.data-bs-slide-to]="i"
                [class.active]="i === 0"
                [attr.aria-current]="i === 0 ? 'true' : null"
                [attr.aria-label]="t('common.slide') + ' ' + (i+1)"></button>
      </div>

      <div class="carousel-inner">
        <div class="carousel-item" *ngFor="let s of serieMSlides; let i = index" [class.active]="i === 0" data-bs-interval="4500">
          <img [src]="s.src" [alt]="s.alt" loading="lazy" class="d-block w-100">
        </div>
      </div>

      <button class="carousel-control-prev" type="button" data-bs-target="#seriesCarousel" data-bs-slide="prev" [attr.aria-label]="t('common.prev')">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#seriesCarousel" data-bs-slide="next" [attr.aria-label]="t('common.next')">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
      </button>
    </div>

    <div class="cta-row mt-cta">
      <a class="btn btn-pro" routerLink="/categoria/chemistry">{{ t('series.btnBio') }}</a>
      <a class="btn btn-glass-blue" routerLink="/cotizar">{{ t('series.btnQuote') }}</a>
    </div>
  </div>
</section>

<!-- ===== Bioquímicos ===== -->
<section class="biochem">
  <div class="container">
    <h2 class="h-left">{{ t('bio.titleA') }} <br> Alphatec Scientific®.</h2>
    <p class="subtitle">{{ t('bio.subtitleA') }} <br> <span class="accent">{{ t('bio.subtitleAccent') }}</span>.</p>

    <div class="cards">
      <article class="card-i">
        <figure class="media-card">
          <video class="media-card__media" src="assets/videos/vid_02.mp4" autoplay muted loop playsinline preload="metadata"
                 controlslist="nodownload noplaybackrate nofullscreen" disablepictureinpicture></video>
        </figure>
        <div class="card-i__body">
          <h3>{{ t('bio.c1.title') }}</h3>
          <p>{{ t('bio.c1.desc') }}</p>
        </div>
      </article>

      <article class="card-i">
        <figure class="media-card">
          <video class="media-card__media" src="assets/videos/vid_01.mp4" autoplay muted loop playsinline preload="metadata"
                 controlslist="nodownload noplaybackrate nofullscreen" disablepictureinpicture></video>
        </figure>
        <div class="card-i__body">
          <h3>{{ t('bio.c2.title') }}</h3>
          <p>{{ t('bio.c2.desc') }}</p>
        </div>
      </article>
    </div>

    <div class="cta-row mt-cta">
      <a class="btn btn-pro" routerLink="/categoria/chemistry">{{ t('bio.btnExplore') }}</a>
      <a class="btn btn-pro-outline" routerLink="/tienda">{{ t('bio.btnAllCats') }}</a>
    </div>
  </div>
</section>

<!-- ===== Microscopios ===== -->
<section class="micros section-dark">
  <div class="container">
    <header class="micros__head">
      <img src="assets/images/astreo_text_black.png" width="150" alt="">
      <h2><small class="text-brand-orange">{{ t('micros.line') }}</small></h2>
      <p class="sub">{{ t('micros.sub') }}</p>
    </header>

    <div class="micros__grid">
      <article class="micros__card panel-card" *ngFor="let m of microsModels; trackBy: trackBySlug">
        <h3 class="micros__title">{{ m.title }}</h3>

        <div class="micros__main">
          <img
            [src]="imgPath(m.views[selectedViewIndex[m.slug] || 0])"
            [alt]="m.title + ' ' + t('micros.view') + ' ' + ((selectedViewIndex[m.slug] || 0) + 1)"
            loading="lazy" />
        </div>

        <ul class="micros__thumbs">
          <li class="thumb" *ngFor="let v of (m.views | slice:0:4); let j = index">
            <button
              type="button"
              class="thumb__btn"
              [class.active]="(selectedViewIndex[m.slug] || 0) === j"
              (click)="selectView(m.slug, j)"
              [attr.aria-label]="t('micros.thumb') + ' ' + (j + 1)">
              <img [src]="imgPath(v)" [alt]="m.title + ' ' + t('micros.thumb') + ' ' + (j + 1)" loading="lazy" />
            </button>
          </li>
        </ul>
      </article>
    </div>

    <div class="cta-row mt-cta">
      <a class="btn btn-pro" routerLink="/categoria/microscopes">{{ t('micros.btnMore') }}</a>
      <a class="btn btn-glass-blue" routerLink="/cotizar">{{ t('micros.btnQuote') }}</a>
    </div>
  </div>
</section>

<!-- ===== Conectando resultados ===== -->
<section class="connect">
  <div class="container">
    <div class="connect__head">
      <img src="assets/logo/logo_text_alp_black.png" width="250" alt="">
      <h2>{{ t('connect.title') }}</h2>
      <p class="sub"><strong>Alphanapsis®</strong> {{ t('connect.sub') }}</p>
    </div>

    <div class="connect__grid">
      <figure class="connect__media">
        <img src="assets/images/alphanapsisTablet.jpg" [alt]="t('connect.imgAlt')" loading="lazy">
      </figure>

      <div class="connect__content">
        <div>
          <img src="assets/logo/logo_text_alp_black.png" width="130" alt="Alphanapsis">
          {{ t('connect.paragraph') }}
        </div>

        <div class="accordion accordion-flush lis-accordion" id="lisAccordion">
          <div class="accordion-item" *ngFor="let it of lisItems; let i = index">
            <h2 class="accordion-header" [id]="'lisHeading'+i">
              <button class="accordion-button collapsed d-flex align-items-center gap-3"
                      type="button" data-bs-toggle="collapse"
                      [attr.data-bs-target]="'#lisCollapse'+i"
                      aria-expanded="false"
                      [attr.aria-controls]="'lisCollapse'+i">
                <i class="bi" [ngClass]="it.icon"></i>
                <span class="flex-grow-1 acc-title">{{ it.title }}</span>
              </button>
            </h2>
            <div [id]="'lisCollapse'+i" class="accordion-collapse collapse"
                 role="region" [attr.aria-labelledby]="'lisHeading'+i"
                 data-bs-parent="#lisAccordion">
              <div class="accordion-body">
                <p class="mb-0">{{ it.description }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="cta-row">
          <a routerLink="/software/lis" class="btn btn-pro">{{ t('connect.btnLis') }}</a>
          <a routerLink="/software" class="btn btn-pro-outline">{{ t('connect.btnMore') }}</a>
        </div>
      </div>
    </div>

    <div class="brands-row" [attr.aria-label]="t('connect.brandsAria')">
      <div class="brand-slot" *ngFor="let src of images; index as i">
        <div class="brand-card">
          <img [src]="src" [alt]="t('connect.brand') + ' ' + (i + 1)" />
        </div>
      </div>
    </div>
  </div>
</section>
